import {
  GetInternDetailsResponse,
  InternAddTopicProps,
  InternCollegeResponse,
  InternDetailsAddEdit,
  IInternDetailsProps,
  InternEmployeeName,
  InternEmployeeResponse,
  InternTopicResponse,
  InterHistoryProps,
  internProps,
} from '../../../types/EmployeeDirectory/InternDetails/internDetailsTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'
import { internDetailsApiConfig, AllowedHttpMethods } from '../apiList'

const getInternDetailsList = async (
  props: IInternDetailsProps,
): Promise<GetInternDetailsResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.getInternDetails,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex ?? 20,
      startIndex: props.startIndex ?? 0,
      searchStr: props.searchStr,
      topic: props.topic,
      college: props.college,
      technology: props.technology,
      statusName: props.statusName,
      selectionDate: props.selectionDate,
      from: props.from,
      to: props.to,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const addIntern = async (
  props: InternDetailsAddEdit,
): Promise<GetInternDetailsResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.addInternDetails,
    method: AllowedHttpMethods.post,
    data: {
      firstName: props.firstName,
      middleName: props.middleName,
      fullName: props.fullName,
      lastName: props.lastName,
      email: props.email,
      phoneNumber: props.phoneNumber,
      collegedetails: props.collegedetails,
      startDate: props.startDate,
      endDate: props.endDate,
      topic: props.topic,
      assignedTo: props.assignedTo,
      currentLocation: props.currentLocation,
      emergencyContactName: props.emergencyContactName,
      maritalStatus: props.maritalStatus,
      dob: props.dob,
      country: props.country,
      userName: props?.userName,
      nickName: props?.nickName,
      marriageDate: props?.marriageDate,
      nationalityName: props?.nationalityName,
      alternateEmail: props?.alternateEmail,
      pan: props?.pan,
      statusName: props?.statusName,
      gender: props?.gender,
      remarks: props?.remarks,
      technology: props.technology,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const editIntern = async (
  props: InternDetailsAddEdit,
): Promise<GetInternDetailsResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.editInternDetails,
    method: AllowedHttpMethods.post,
    data: {
      internId: props?.internId,
      firstName: props.firstName,
      middleName: props.middleName,
      fullName: props.fullName,
      lastName: props.lastName,
      email: props.email,
      phoneNumber: props.phoneNumber,
      collegedetails: props.collegedetails,
      startDate: props.startDate,
      endDate: props.endDate,
      topic: props.topic,
      assignedTo: props.assignedTo,
      currentLocation: props.currentLocation,
      emergencyContactName: props.emergencyContactName,
      maritalStatus: props.maritalStatus,
      dob: props.dob,
      country: props.country,
      userName: props?.userName,
      nickName: props?.nickName,
      marriageDate: props?.marriageDate,
      nationalityName: props?.nationalityName,
      alternateEmail: props?.alternateEmail,
      pan: props?.pan,
      statusName: props?.statusName,
      gender: props?.gender,
      remarks: props?.remarks,
      technology: props.technology,
      inActiveComments: props?.inActiveComments,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const addTopic = async (props: InternAddTopicProps): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.addTopic,
    method: AllowedHttpMethods.post,
    params: {
      topic: props.topic,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getAllTopics = async (): Promise<InternTopicResponse[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.getAllTopics,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteTopic = async (props: number): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.deleteTopic,
    method: AllowedHttpMethods.delete,
    params: {
      id: props,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const addEmployeeName = async (props: InternEmployeeName): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.addEmployeeName,
    method: AllowedHttpMethods.post,
    params: {
      employeeName: props.employeeName,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getAllEmployeeNames = async (): Promise<InternEmployeeResponse[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.getAllEmployeeNames,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteEmployeeName = async (props: number): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.deleteEmployeeName,
    method: AllowedHttpMethods.delete,
    params: {
      id: props,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getAllCollegeNames = async (): Promise<InternCollegeResponse[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.getAllCollegeNames,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const exportInternData = async (
  props: IInternDetailsProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.exportInternDetails,
    method: AllowedHttpMethods.get,
    params: {
      startIndex: props.startIndex,
      endIndex: props.endIndex,
      searchStr: props.searchStr,
      topic: props.topic,
      college: props.college,
      technology: props.technology,
      statusName: props.statusName,
      selectionDate: props.selectionDate,
      from: props.from,
      to: props.to,
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const internTimelineApi = async (
  props: internProps,
): Promise<InterHistoryProps[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: internDetailsApiConfig.internTimelineDetails,
    method: AllowedHttpMethods.get,
    params: {
      internId: props.internId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}
export const internDetailsApi = {
  getInternDetailsList,
  addIntern,
  editIntern,
  addTopic,
  getAllTopics,
  deleteTopic,
  addEmployeeName,
  getAllEmployeeNames,
  deleteEmployeeName,
  getAllCollegeNames,
  exportInternData,
  internTimelineApi,
}
